import React from "react";
import HelmetCustom from "../../components/HelmetCustom";
import MainLayout from "../../components/MainLayout";

export default function NoMatch({ history }) {
  return (
    <MainLayout history={history}>
      <HelmetCustom pageTitle="Página não encontrada" />
      <h1>Página não encontrada</h1>
    </MainLayout>
  );
}
